import { Endpoint } from "../config";

export type AuthEndpointType =
  | "signIn"
  | "otpVerification"
  | "resendOTP"
  | "changePassword"
  | "forgotPassword"
  | "verifyEmailOtp"
  | "resendEmailOTP"
  | "resetPassword"
  | "getInvitation"
  | "signUp"
  | "refreshToken"
  | "logout";

export const authEndpoints: Record<AuthEndpointType, Endpoint> = {
  signIn: {
    url: "login/",
  },
  otpVerification: {
    url: "verify-otp",
  },
  resendOTP: {
    url: "send-otp",
  },
  changePassword: {
    url: "change-password/",
  },
  forgotPassword: {
    url: "forgot-password/",
  },
  verifyEmailOtp: {
    url: "otp-verify",
  },
  resendEmailOTP: {
    url: "send-otp/",
  },
  resetPassword: {
    url: "reset-password/",
  },
  getInvitation: {
    url: "get-invitation/",
  },
  signUp: {
    url: "sign-up/",
  },
  refreshToken: {
    url: "generate/token/",
  },
  logout: {
    url: "logout/",
  },
};
